import {
  HeadingGroup,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
  ConfirmationBox,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import useRjList from "./useRjList";
import UpdateRj from "../UpdateRj";
import { ImageCard } from "../../Global/ImageCard";
import Filter from "../Filter";
import Style from "../rj.module.scss";

const RjList = () => {
  const {
    rj,
    rjState,
    activeId,
    currentPage,
    activeFilter,
    showCreateModal,
    paginationOptions,
    isFetching,
    isLoading,
    showDeleteModal,
    imageData,
    titleImageData,
    showImageModal,
    isEditData,
    filterShow,
    setFilterShow,
    closeDeleteModal,
    handlePagination,
    handlePageSize,
    refetch,
    handleSort,
    handleSearch,
    handleRjDataEditClick,
    handleCreateClick,
    handleEditModal,
    closeModal,
    deleteRjDataClick,
    getRow,
    deleteRj,
    tableFields,
    hasCreatePermission,
    hasEditPermission,
    hasViewPermission,
    hasDeletePermission,
    showDetailsImageModal,
    closeDetailsModal
  } = useRjList();

  return (
    <>
      <HeadingGroup
        title={"RJs"}
        buttonTitle={hasCreatePermission ?? false ? "Add New" : ""}
        extraClassName={`pro-mb-4`}
        handleClick={handleCreateClick}
      />
      <div className="col-12 pro-pb-6">
        <SearchFilters
          showDateRange={false}
          activeFilter={activeFilter}
          showFilters={true}
          onSearchInput={handleSearch}
          loading={isLoading}
          showActions={false}
          handleActionClick={handleEditModal}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          extraFilters={
            <div className="col-auto">
              <button
                className={`pro-btn pro-btn-outline pro-h-100 pro-items-center`}
                onClick={() => setFilterShow(true)}
              >
                <span className="material-symbols-outlined">tune</span>
                <span>Filter</span>
              </button>
            </div>
          }
        />
        <Table
          data={rj?.data?.original?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          showCheckBox={hasEditPermission || hasDeletePermission ? true : false}
          SortIcon={<FaSort />}
          handleEdit={handleRjDataEditClick}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          handleDelete={deleteRjDataClick}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={rjState.currentPageSize}
          assignable={false}
          multiSelect={false}
          clear={rjState.clearSelection}
          editable={hasEditPermission ? true : false}
          deletable={hasDeletePermission ? true : false}
        />
        {rj?.data?.original?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPageCount={Math.ceil(rj?.data?.original?.last_page_number)}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
      </div>
      <ModalLayout
        centered
        show={showDeleteModal}
        handleClose={closeDeleteModal}
      >
        <div className="pro-m-5">
          <ConfirmationBox
            title={`Are you sure you want to delete?`}
            isRight={true}
            cancelText={`Cancel`}
            submitText={`Delete`}
            cancelAction={closeDeleteModal}
            submitAction={deleteRj}
          >
            ConfirmationBox
          </ConfirmationBox>
        </div>
      </ModalLayout>

      <OffCanvasLayout
        show={showCreateModal}
        handleClose={closeModal}
        title={`${isEditData ? "Update Rj Details" : "Create Rj"}`}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
        backdrop={"static"}
      >
        <UpdateRj
          activeId={activeId}
          refetch={refetch}
          isEditData={isEditData}
        />
      </OffCanvasLayout>

      <OffCanvasLayout
        centered={true}
        show={filterShow}
        handleClose={() => {
          setFilterShow(false);
        }}
        title={"Filter"}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <Filter setShowform={setFilterShow} refetch={refetch} />
      </OffCanvasLayout>

      <ModalLayout show={showImageModal} handleClose={closeModal} backdrop="static">
        <ImageCard data={imageData} handleClose={closeModal} />
      </ModalLayout>
      <ModalLayout show={showDetailsImageModal} handleClose={closeDetailsModal} backdrop="static">
        <ImageCard data={titleImageData} handleClose={closeDetailsModal} />
      </ModalLayout>
    </>
  );
};

export default RjList;
